import type { Template } from "@/types";

export const LA_04_H1_V3: Template[] = [
    {
        id: "la-04-h1v3-01",
        name: "LA 01 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 148, y: 0, width: 380, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 849, y: 60, width: 308, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 849, y: 263, width: 151, height: 206, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1008, y: 263, width: 150, height: 206, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-02",
        name: "LA 02 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 93, y: 53, width: 285, height: 424, rotation: 0, imageRotation: 0 },
            { id: "2", x: 385, y: 53, width: 200, height: 128, rotation: 0, imageRotation: 0 },
            { id: "3", x: 385, y: 188, width: 200, height: 289, rotation: 0, imageRotation: 0 },
            { id: "4", x: 860, y: 53, width: 309, height: 424, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-03",
        name: "LA 03 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 191, y: 53, width: 294, height: 425, rotation: 0, imageRotation: 0 },
            { id: "2", x: 855, y: 53, width: 312, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 855, y: 256, width: 153, height: 221, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1016, y: 256, width: 152, height: 221, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-04",
        name: "LA 04 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 46, y: 120, width: 190, height: 290, rotation: 0, imageRotation: 0 },
            { id: "2", x: 244, y: 120, width: 189, height: 290, rotation: 0, imageRotation: 0 },
            { id: "3", x: 441, y: 120, width: 189, height: 290, rotation: 0, imageRotation: 0 },
            { id: "4", x: 722, y: 53, width: 584, height: 424, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-05",
        name: "LA 05 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 104, y: 111, width: 468, height: 300, rotation: 0, imageRotation: 0 },
            { id: "2", x: 782, y: 42, width: 301, height: 449, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1090, y: 42, width: 156, height: 221, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1090, y: 271, width: 156, height: 220, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-06",
        name: "LA 06 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 182, y: 54, width: 152, height: 218, rotation: 0, imageRotation: 0 },
            { id: "2", x: 182, y: 280, width: 311, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 54, width: 152, height: 218, rotation: 0, imageRotation: 0 },
            { id: "4", x: 859, y: 54, width: 310, height: 422, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-07",
        name: "LA 07 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 120, y: 61, width: 280, height: 410, rotation: 0, imageRotation: 0 },
            { id: "2", x: 407, y: 61, width: 142, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 407, y: 269, width: 142, height: 202, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 61, width: 589, height: 410, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-08",
        name: "LA 08 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 43, y: 61, width: 589, height: 410, rotation: 0, imageRotation: 0 },
            { id: "2", x: 794, y: 61, width: 282, height: 410, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1083, y: 61, width: 140, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1083, y: 269, width: 140, height: 202, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-09",
        name: "LA 09 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 43, y: 77, width: 236, height: 377, rotation: 0, imageRotation: 0 },
            { id: "2", x: 287, y: 77, width: 236, height: 377, rotation: 0, imageRotation: 0 },
            { id: "3", x: 531, y: 77, width: 236, height: 377, rotation: 0, imageRotation: 0 },
            { id: "4", x: 775, y: 77, width: 533, height: 377, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h1v3-10",
        name: "LA 10 - H1V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h1_v3_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 43, y: 77, width: 236, height: 377, rotation: 0, imageRotation: 0 },
            { id: "2", x: 287, y: 77, width: 533, height: 377, rotation: 0, imageRotation: 0 },
            { id: "3", x: 828, y: 77, width: 236, height: 377, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1072, y: 77, width: 236, height: 377, rotation: 0, imageRotation: 0 }
        ],
    }
];